import React, { useRef, useState, useEffect } from 'react';
import CustomSelect from '../../common/CustomSelect';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiCalendar } from "react-icons/fi";
import SchedulerStatus from '../../Enum/SchedulerStatus';
import InformationMedium from '../../Enum/InformationMedium';

const MeetingFilter = ({ presonList, meetingPersonData, onApplyFilters, onClearFilters, filters }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [selectedAssistant, setSelectedAssistant] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedInitialInfoMedium, setSelectedInitialInfoMedium] = useState(null);
  const [selectedFinalInfoMedium, setSelectedFinalInfoMedium] = useState(null);

  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  useEffect(() => {
    setStartDate(filters?.startDate ? new Date(filters.startDate) : null);
    setEndDate(filters?.endDate ? new Date(filters.endDate) : null);
    setSelectedPerson(filters?.meetingPerson || null);
    setSelectedAssistant(filters?.assistant || null);
    setSelectedStatus(filters?.status || null);
    setSelectedInitialInfoMedium(filters?.initialInfoMedium || null);
    setSelectedFinalInfoMedium(filters?.finalInfoMedium || null);
  }, [filters]);

  const handleApplyFilter = () => {
    const filters = {
      startDate,
      endDate,
      meetingPerson: selectedPerson,
      assistant: selectedAssistant,
      status: selectedStatus,
      initialInfoMedium: selectedInitialInfoMedium,
      finalInfoMedium: selectedFinalInfoMedium,
    };
    onApplyFilters(filters);
  };

  const handleClearFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedPerson(null);
    setSelectedAssistant(null);
    setSelectedStatus(null);
    setSelectedInitialInfoMedium(null);
    setSelectedFinalInfoMedium(null);
    onClearFilters();
  };

  return (
    <div className="space-y-4">
      <CustomSelect
        placeholder="Meeting Person"
        options={meetingPersonData}
        value={selectedPerson}
        onChange={(value) => setSelectedPerson(value)}
      />

      <CustomSelect
        placeholder="Personal Assistance"
        options={presonList.map((list) => ({
          value: list.id,
          label: list.name,
        }))}
        value={selectedAssistant}
        onChange={(value) => setSelectedAssistant(value)}
      />

      <CustomSelect
        placeholder="Meeting Status"
        options={SchedulerStatus}
        value={selectedStatus}
        onChange={(value) => setSelectedStatus(value)}
      />

      <CustomSelect
        placeholder="Initial Info Medium"
        options={InformationMedium}
        value={selectedInitialInfoMedium}
        onChange={(value) => setSelectedInitialInfoMedium(value)}
      />

      <CustomSelect
        placeholder="Final Info Medium"
        options={InformationMedium}
        value={selectedFinalInfoMedium}
        onChange={(value) => setSelectedFinalInfoMedium(value)}
      />

      <div className="relative w-full pr-10 border-2 border-customGreen rounded-md">
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          placeholderText="Start Date"
          maxDate={new Date()}
          dateFormat="dd/MM/yyyy"
          className="w-[400px] py-2 px-3 focus:outline-none text-gray-700"
          ref={startDateRef}
        />
        <FiCalendar
          className="absolute right-3 top-3  text-gray-500 cursor-pointer"
          onClick={() => startDateRef.current.setFocus()}
        />
      </div>

      <div className="relative w-full pr-10 border-2 border-customGreen rounded-md">
        <DatePicker
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          disabled={!startDate}
          placeholderText={`${startDate ? 'End Date' : 'Select Start Date'}`}
          minDate={startDate}
          dateFormat="dd/MM/yyyy"
          className="w-[400px] py-2 px-3  focus:outline-none text-gray-700"
          ref={endDateRef}
        />
        <FiCalendar
          className="absolute right-3 top-3 text-gray-500 cursor-pointer"
          onClick={() => endDateRef.current.setFocus()}
        />
      </div>

      <button
        className="bg-primary text-white py-2 px-4 rounded-md transition duration-300 w-full mt-4"
        onClick={handleApplyFilter}
      >
        Apply Filters
      </button>
      <button
        className="bg-white text-red-500 border border-primary py-2 px-4 rounded-md hover:bg-gray-100 transition duration-300 w-full"
        onClick={handleClearFilters}
      >
        Clear Filters
      </button>
    </div>
  );
};

export default MeetingFilter;